export const measures = {
  headerHeight: '72px',
  sidebarWidth: '72px',
  leftColumnWidth: '382px',
  eventFooterColumnWidth: '350px',
  viewportHeight: `calc(var(--app-height) - 72px)`,
  listPageContentMaxWidth: '1400px',
};
